// What kind of scene is loaded, and therefore which surfaces may talk to the merchant-shop API.
//
// 🔴 ASK-129 §E2E102-rerun item 3, and it is a regression of §studio-gate's own fix. Making the
// shop-layer sections unconditional was right — fixtures, packs, the selling space and the
// assortment need no template — but their MOUNTS then started firing merchant-shop admin calls on
// `galleria-hub`, which is not a merchant shop and 404s all of them. Measured in Vanessa's console:
// `curation/presets` · `curation/pins` · `merch-zones` · `shell-composition`, four 404s on hub
// entry. The hub-skip that already existed (`_activeIsMerchantShop`) covered anchors, knobs and
// telemetry and none of these four.
//
// 🔴 AND THE DISCRIMINATOR IS THE SCENE KIND, NOT THE TEMPLATE. `_activeIsMerchantShop` required
// `scene.template` to be present, which was the same mistake §studio-gate spent a whole pass
// removing from the panel: a COMPOSED SHELL is a real merchant shop with a real GCG row and no
// template block. Gating merchant calls on a template means a shop whose knob block has not been
// minted yet is treated as the hub — no knob hydrate, no anchors — which is precisely the shop this
// ASK exists for. A hub is a hub because its bootstrap says `kind: "hub"`, and for no other reason.
//
// Pure (no DOM, no fetch, no imports) so it can be read from the customer path, the editor path and
// a unit test alike. `test-shop-capability` pins the four cases.

/**
 * Is the ACTIVE scene a merchant shop — something with a GCG row that admin endpoints serve?
 * @param {object} app the runtime app (needs `state.activeProjectId` + `projectBootstraps`)
 */
export function isMerchantShopScene(app) {
	const id = app?.state?.activeProjectId;
	if (!id) return false;                                       // nothing loaded → no opinion, no calls
	return app?.projectBootstraps?.[id]?.kind !== "hub";
}

/**
 * The same answer with its reason attached, for the surfaces that want to SAY why they are quiet
 * rather than just going quiet. "Absent" and "empty" are different states (ways-of-working §6) and
 * so are "this scene cannot have packs" and "this shop has no packs".
 * @returns {{ ok: boolean, reason: "no-scene"|"hub"|null }}
 */
export function merchantShopCapability(app) {
	const id = app?.state?.activeProjectId;
	if (!id) return { ok: false, reason: "no-scene" };
	if (app?.projectBootstraps?.[id]?.kind === "hub") return { ok: false, reason: "hub" };
	return { ok: true, reason: null };
}
